import React from 'react';

interface Context {
  readerMessageLimitReached: boolean;
  setReaderMessageLimitReached: (value: boolean) => void;
}

// These values are needed all the way down in DownloadButtonWrapper and other nested components.
// Rather than prop drill down all the way from TopCard,
// this value passes through context to make things simpler.
export const ReaderMessageContext = React.createContext<Context>({
  // The purpose of readerMessageLimit is to improve the INP of the reader message form
  // by loading in this limit when the TopCard loads and passing it on to the relevannt
  // places that render ReaderMessageForm through this context instead of prop drilling.
  readerMessageLimitReached: true,
  setReaderMessageLimitReached: () => {},
});
